const T = require('prop-types');

const internals = {};

internals.nonEmptyArray = (props, propName, componentName) => {

    const value = props[propName];

    if (!Array.isArray(value) || !value.length) {
        return new Error(`${componentName} is waiting for ${propName}`);
    }

    return null;
};

internals.normalizeEmail = (email) => {

    return String(email || '').trim().toLowerCase();
};

internals.isNearpeerInternalUser = (user) => {

    const email = internals.normalizeEmail(user?.email);

    return /^[^@\s]+@(nearpeer\.net|nearpeer\.com)$/.test(email);
};

internals.canViewAllDashboardSchools = (user) => {

    return internals.isNearpeerInternalUser(user);
};

internals.getDashboardSchoolOptions = ({ currentUser, schools = [] }) => {

    if (internals.canViewAllDashboardSchools(currentUser)) {
        return schools;
    }

    return schools.filter((school) => school.id === currentUser?.schoolId);
};

internals.getDashboardSchoolId = ({ currentUser, requestedSchoolId }) => {

    if (internals.canViewAllDashboardSchools(currentUser)) {
        return requestedSchoolId || currentUser?.schoolId || '';
    }

    return currentUser?.schoolId || '';
};

internals.getDashboardFilterRoles = (roles = []) => {

    return (roles || [])
        .filter((role) => role && role.name !== 'superuser' && role.name !== 'observer')
        .map((role) => ({
            id: role.id,
            label: role.label || role.name,
            name: role.name
        }));
};

exports.dependencyPropTypes = {
    currentUser: T.object.isRequired,
    schools: internals.nonEmptyArray
};

exports.canViewAllDashboardSchools = internals.canViewAllDashboardSchools;
exports.getDashboardSchoolOptions = internals.getDashboardSchoolOptions;
exports.getDashboardSchoolId = internals.getDashboardSchoolId;
exports.getDashboardFilterRoles = internals.getDashboardFilterRoles;

if (process.env.NODE_ENV === 'test') {
    exports._internals = internals;
}
